@if (realPageNumber > 0) {
    <div class="page-favorite-item">
    <span class="logo">
      <img [src]="'icon-lesezeichen-active.png' | asset " alt="Lesezeichen-Icon"/>
    </span>
        <span (click)="turnToPage()"
              (keydown.enter)="turnToPage()"
              (keydown.space)="$event.preventDefault(); turnToPage()"
              class="element-wrapper"
              tabindex="0"
              role="button"
        >
        <span class="description">  {{ favoriteName }}  </span>
            @if (pageFavorite.assignmentSlug) {
                <span (click)="openQuicklink(pageFavorite.assignmentSlug)"
                      (keydown.enter)="openQuicklink(pageFavorite.assignmentSlug)"
                      (keydown.space)="$event.preventDefault(); openQuicklink(pageFavorite.assignmentSlug)"
                      class="quicklink"
                      tabindex="0"
                      role="button"
                >
                    <i class="fas fa-link"
                        data-bs-placement="bottom" data-bs-toggle="tooltip"
                        title="Aufgabe {{ pageFavorite.assignmentSlug }} öffnen">
                    </i>
                </span>
            }
            <span class="page-number">{{ sideNumberToShow }}</span>
        </span>
    </div>
}
